import React from "react";
import { FiBell, FiMail } from "react-icons/fi";
import styles from "./SubscriptionsSection.module.css";

const SubscriptionsSection = () => {
  return (
    <div className={styles.subscriptionsRoot}>
      <section className={styles.heroCard}>
        <div className={styles.heroIcon}>
          <FiBell />
        </div>
        <div>
          <span>Повідомлення</span>
          <h1>Підписки</h1>
          <p>
            Тут згодом будуть налаштування розсилок, персональних пропозицій та
            сповіщень про товари.
          </p>
        </div>
      </section>

      <section className={styles.emptyCard}>
        <div className={styles.emptyIcon}>
          <FiMail />
        </div>
        <h2>Налаштування підписок ще не активовані</h2>
        <p>
          Ми підготуємо окремі перемикачі для email, акцій, нагадувань про
          улюблені товари та персональні добірки після підключення відповідного
          backend-функціоналу.
        </p>
      </section>
    </div>
  );
};
export default SubscriptionsSection;
